module.exports = Object.freeze({
    ButtonSize: {
      DEFAULT: 'default',
      SMALL: 'small',
    },
  });